module.exports = __webpack_public_path__ + "static/media/IMG_0219.2412b434.jpg";